(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onyx-article"]) return;
  try {
    
(function () {
  'use strict';
  /* Contents list: open on desktop (where it is a sticky sidebar), collapsible on mobile, and highlight
     the section being read. */
  function initToc(toc) {
    if (toc.dataset.oaReady) return;
    toc.dataset.oaReady = '1';
    var mq = window.matchMedia('(min-width: 990px)');
    var sync = function () { if (mq.matches) toc.open = true; };
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
    var links = Array.prototype.slice.call(toc.querySelectorAll('a[href^="#"]'));
    if (!('IntersectionObserver' in window) || !links.length) return;
    var byId = {};
    links.forEach(function (a) { byId[decodeURIComponent(a.getAttribute('href').slice(1))] = a; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (a) { a.removeAttribute('aria-current'); });
        var a = byId[e.target.id];
        if (a) a.setAttribute('aria-current', 'true');
      });
    }, { rootMargin: '-15% 0px -75% 0px' });
    Object.keys(byId).forEach(function (id) { var h = document.getElementById(id); if (h) io.observe(h); });
    links.forEach(function (a) { a.addEventListener('click', function () { if (!mq.matches) toc.open = false; }); });
  }
  function run() { document.querySelectorAll('[data-oa-toc]').forEach(initToc); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onyx-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  /* <onyx-faq-nav> — builds the topic list from the FAQ groups rendered in the same section.
     Nested theme blocks are not visible to Liquid through section.blocks, so the list is made here,
     rebuilt when the editor adds, removes, renames or reorders a group, and highlights the topic in view. */
  class OnyxFaqNav extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-onyx-faq]');
      this.nav = this.querySelector('nav');
      this.list = this.querySelector('[data-faq-nav]');
      if (!this.root || !this.nav || !this.list) return;
      this.build = this.build.bind(this);
      this.build();
      this.observer = new MutationObserver((records) => {
        if (records.every((r) => this.contains(r.target))) return;
        clearTimeout(this.timer);
        this.timer = setTimeout(this.build, 60);
      });
      this.observer.observe(this.root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-faq-title', 'id'] });
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.spy) this.spy.disconnect();
      clearTimeout(this.timer);
    }
    groups() {
      return Array.from(this.root.querySelectorAll('[data-faq-group]')).filter((g) => g.id);
    }
    build() {
      const groups = this.groups();
      const signature = groups.map((g) => g.id + '|' + this.title(g) + '|' + g.querySelectorAll('[data-faq-item]').length).join('~');
      if (signature === this.signature) return;
      this.signature = signature;
      this.list.textContent = '';
      groups.forEach((group) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + group.id;
        const label = document.createElement('span');
        label.textContent = this.title(group);
        const count = document.createElement('span');
        count.className = 'oa-faq-nav__count';
        count.textContent = group.querySelectorAll('[data-faq-item]').length;
        count.setAttribute('aria-hidden', 'true');
        a.append(label, count);
        li.appendChild(a);
        this.list.appendChild(li);
      });
      this.nav.hidden = groups.length < 2;
      this.watch(groups);
      const search = this.root.querySelector('onyx-faq-search');
      if (search && typeof search.apply === 'function' && search.input) search.apply();
    }
    title(group) {
      const heading = group.querySelector('.oa-faq-group__title');
      return (group.dataset.faqTitle || (heading && heading.textContent) || '').trim();
    }
    watch(groups) {
      if (this.spy) this.spy.disconnect();
      if (!('IntersectionObserver' in window)) return;
      this.spy = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { if (entry.isIntersecting) this.mark(entry.target.id); });
      }, { rootMargin: '-20% 0px -70% 0px' });
      groups.forEach((g) => this.spy.observe(g));
    }
    mark(id) {
      this.list.querySelectorAll('a').forEach((a) => {
        if (a.getAttribute('href') === '#' + id) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    }
  }
  if (!customElements.get('onyx-faq-nav')) customElements.define('onyx-faq-nav', OnyxFaqNav);

  /* Deep links (/pages/faqs#how-much-does-delivery-cost): open the answer and bring it into view. */
  function openFaqFromHash() {
    var id = '';
    try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (e) { id = window.location.hash.slice(1); }
    var target = id && document.getElementById(id);
    if (!target || !target.matches('details[data-faq-item]')) return;
    target.open = true;
    requestAnimationFrame(function () { target.scrollIntoView({ block: 'start' }); });
  }
  window.addEventListener('hashchange', openFaqFromHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openFaqFromHash); else openFaqFromHash();
})();

  } catch(e) { console.error(e); }
})();
})();
